module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/005_Preface#fm-1"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Introduction#fm-2"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter01#ch-1"
    }
  }, [_vm._v("1. Discipleship as Transformation of Self")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Discipleship before the Reformation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Post-Reformation Discipleship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Discipleship under Threat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Shaping a New Vision")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. A Critical Analysis of the Two Visions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Discipleship in Churches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Imitating Saints")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Suggested_Reading#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Suggested Reading")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45de19eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Contents.vue
// module id = 66
// module chunks = 0